/* src/app/components/grouped-binding-selector/grouped-binding-selector.component.scss */
@media (min-width: 1104px) and (max-width: 1815px) {
  .containerDiv {
    zoom: 0.75;
  }
}
.containerDiv {
  padding: 10px;
  background-color: #f6f6f6;
  border: 10px solid white;
  border-radius: 20px;
}
.title {
  color: white;
  font-size: 20px;
  font-weight: 500;
  font-family: "Barlow Semi Condensed", sans-serif;
  text-wrap: pretty;
}
.tooltip-icon {
  width: 20px;
  height: 20px;
  z-index: 99;
  cursor: pointer;
}
ion-button {
  --border-color: #949494;
  --border-style: solid;
  --border-width: 1px;
  --background: #f6f6f6;
  --background-activated: #fff0c6;
  --background-focused: #fff0c6;
  --background-hover: #fff0c6;
  margin: 0;
}
ion-button .image-option {
  color: black;
  min-height: 42px;
  min-width: 28px;
}
ion-button .title {
  color: #000;
  font-size: 20px;
  font-weight: 500;
  font-family: "Barlow Semi Condensed", sans-serif;
  text-wrap: pretty;
}
ion-button .sub-title {
  color: #cbcbcb;
  font-size: 16px;
  font-weight: 500;
  font-family: "Barlow Semi Condensed", sans-serif;
  text-wrap: balance;
}
ion-button::part(native) {
  padding: 9px;
  border-color: #949494;
}
ion-button.selected {
  --border-width: 2px;
}
ion-button.selected::part(native) {
  border-color: var(--ion-color-primary);
  background-color: rgba(67, 192, 246, 0.0509803922);
}
/*# sourceMappingURL=grouped-binding-selector.component-WYN4R7RR.css.map */
